<template>
  <div
    class="w-full px-4 py-2 flex tablet-h:rounded-[10px] tablet-h:p-1.5 tablet-h:pr-2.5"
    :class="classes"
  >
    <div class="mr-[9px] size-11 shrink-0 p-0.5">
      <DacrMarkIcon class="size-full text-gray-800" />
    </div>
    <div
      class="min-w-0 flex-1 text-[14px] leading-[19px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <div class="mb-[3px]">Register your first work to get started</div>
      <div class="text-[12px] leading-[18px] opacity-60">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
      <Button
        class="w-full mt-2"
        size="md"
        variant="primary"
        @click.stop="showUploadDialog"
      >
        Register a work
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUploadFlow } from '@/features/upload/composables/useUploadFlow'
import type { Notification } from '@/shared/graphql/legacy/generated'
import { DacrMarkIcon } from '@dacr/icons'
import { Button } from '@dacr/library'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed } from 'vue'

const props = defineProps<{
  notification: Notification
}>()

const { showUploadDialog } = useUploadFlow()

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-700/10': !props.notification.read,
}))
</script>
